import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { useTranslate } from '@im/react-localization';
import CloseIcon from '@mui/icons-material/Close';

const ExamplesData = [
  {
    fields: [
      {
        key: 'SKU List Price',
        value: '$100.00',
      },
      {
        key: 'SKU Cost',
        value: '$85.00',
      },
      {
        key: 'Desired Modifier',
        value: '2.50%',
      },
      {
        key: 'Desired SKU Price',
        value: '$87.18',
      },
    ],
    type: 'Replacement Cost',
  },
  {
    fields: [
      {
        key: 'SKU List Price',
        value: '$100.00',
      },
      {
        key: 'SKU Cost',
        value: '$85.00',
      },
      {
        key: 'Desired Modifier',
        value: '-2.50%',
      },
      {
        key: 'Desired SKU Price',
        value: '$97.50',
      },
    ],
    type: 'Retail Price',
  },
];

const PricingExample = (props: { setOpen: (c: boolean) => void }) => {
  const translate = useTranslate();

  return (
    <Stack
      borderRadius={0.08}
      direction="column"
      m={-1.2}
      maxWidth={'fit-content'}
      ml={-5.1}
      mt={-3}
      px={3}
      py={1.2}
      spacing={1.3}
    >
      <Stack direction="row" mr={-10} spacing={33}>
        <Typography
          color="black"
          fontSize={'.90rem'}
          fontWeight={'bold'}
          variant="body2"
        >
          {translate('Pricing.MarginExamples')}
        </Typography>
        <CloseIcon onClick={() => props.setOpen(false)} />
      </Stack>
      <Stack direction="row" flexWrap={'wrap'} gap={3.5}>
        {ExamplesData.map((d) => (
          <Stack
            direction="column"
            flex={1}
            gap={0.3}
            key={d.type}
            maxWidth={'30%'}
            minHeight={100}
            minWidth={180}
            mt={1}
            spacing={0.1}
          >
            <Typography
              color="black"
              component="div"
              flex={2}
              fontSize={'.75rem'}
              fontWeight={'bold'}
              variant="body1"
            >
              {d.type}
            </Typography>

            {d.fields.map((f) => (
              <Stack direction={'row'} key={f.key} padding={0} spacing={0.1}>
                <Typography
                  color={'#646464'}
                  flex={2}
                  fontSize={'.75rem'}
                  variant="body2"
                >
                  {f.key}
                </Typography>
                <Typography
                  color={'#646464'}
                  flex={1}
                  fontSize={'.75rem'}
                  fontWeight={600}
                  variant="body2"
                >
                  {f.value}
                </Typography>
              </Stack>
            ))}
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default PricingExample;
